export default "__VITE_ASSET__BgjXjVdO__"